import qs from 'qs';
import RESTFUL_axios  from '@/api/restful_axois';
import apiError       from '@/api/apierror';

const RESTFUL_fn = (apiType, reqData) => {
  var apiName = 'publesson';
  var reqName = apiName+'_'+apiType;
  var apiConfigs = {
    _getLessonInfo: {
      url: '/saasajax/school.ajax.php?action=getPublicClassInfo',
      data:  ()=> {
        var data = {}
        if (reqData.lessonKey) {
          data.lessonKey = reqData.lessonKey
        } else {
          data.classSN = reqData.classSN
        }
        return data;
      },
      attrs:{
        withCredentials: true,
      },
      transformResponse: (res) => {
        switch (res.error_info.errno) {
          case 1:
            var resData = res.data;
            var lessonInfoData={};
            if(resData){
              lessonInfoData = {
                lessonId:           resData.classId,
                courseLogo:         resData.courseWare && JSON.parse(resData.courseWare).CourseImg.Mpic,
                lessonName:         resData.className,
                lessonStartTime:    resData.classBtime*1000,
                schoolName:         resData.schoolName,
                druation:           (resData.classEtime-resData.classBtime)*1000,
                teacherLogo:        resData.teacherLogo,
                teacherName:        resData.teacherName,
                schoolIntroduction: resData.schoolIntroduce,
                signUpStatus:       (resData.classStatus=='3') ? 'lessonEnd':
                                    (!(resData.studentNum*1>resData.classStudentNum*1)) ? 'lessonStuFull':''
              };
            }
            return {
              lessonInfoData:lessonInfoData
            }
          case 104:
          case 304:
          case 212:
            return res.error_info.errno
            break;
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_'+apiType].url,
              req: reqData,
              res: res
            })
        }
      }
    },
    _userRegister: {
      url: '/saasajax/user.ajax.php?action=userRegister',
      data: function () {
        var phoneNumber = reqData.phoneNumber.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '');
        var serverPostData = {
          telephone:(reqData.selectArea=='0086')?
                  (phoneNumber):(reqData.selectArea+'-'+phoneNumber),
          identifyCode: reqData.msgCode.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, ''),
          nickName: reqData.nickName,
          password:reqData.password.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, ''),
          isLogin:reqData.isLogin
        }
        return serverPostData;
      },
      attrs:{
        withCredentials: true,
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 111:
            return res.error_info.errno
            break;
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro:res.error_info.error,
              url: apiConfigs['_'+apiType].url,
              req: reqData,
              res: res
            })
        }
      }
    },
    _addlessonStu: {
      url: '/saasajax/openclass.ajax.php?action=addClassStudent',
      data: function () {
        var phoneNumber = reqData.phoneNumber.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '');
        var serverPostData = {
          classId:reqData.lessonId,
          account:(reqData.selectArea=='0086')?
                  (phoneNumber):(reqData.selectArea+'-'+phoneNumber),
          identifyCode: reqData.msgCode.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '')
        }
        reqData.nickName && (serverPostData.name = reqData.nickName)
        return serverPostData;
      },
      attrs:{
        withCredentials: true,
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 128:
          case 111:
          case 129:
          // case 145:
          case 157:
          case 166:
          case 212:
          case 304:
          case 329:
            return res.error_info.errno
            break;
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_'+apiType].url,
              req: reqData,
              res: res
            })
        }
      }
    },
    _check: {
      url: '/saasajax/user.ajax.php?action=checkRegister',
      data: function () {
        var serverPostData = {
          telephone:reqData.telephone.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '')
        }
        return serverPostData;
      },
      attrs:{
        withCredentials: true,
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 113:
            return false
            break;
          case 104:
          case 134:
            return res.error_info.errno
            break;
          case 135:
            return true
            break;
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_'+apiType].url,
              req: reqData,
              res: res
            })
        }
      }
    },
    _sendCode: {
      url: '/saasajax/user.ajax.php?action=sendIdentifyCode',
      data: function () {
        var phoneNumber = reqData.phoneNumber.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '');
        var serverPostData = {
          telephone:(reqData.selectArea=='0086')?
                    (phoneNumber):(reqData.selectArea+'-'+phoneNumber),
          graphicCode:reqData.picCode.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '')
        }
        return serverPostData;
      },
      attrs:{
        withCredentials: true,
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
            return true
            break;
          case 104:
          case 108:
          case 109:
          case 110:
          case 134:
          case 346:
            return res.error_info.errno
            return false
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_'+apiType].url,
              req: reqData,
              res: res
            })
        }
      }
    },
  }
  return RESTFUL_axios({
    reqName:reqName,
    reqConfig:apiConfigs['_'+apiType],
    reqData:reqData,
  });
}
export default RESTFUL_fn
